import { useNavigate } from "react-router-dom";
import type { Organization } from "../../types/user";
import styles from "./OrganizationCard.module.css";

interface OrganizationCardProps {
  organization: Organization;
  memberCount?: number;
}

export function OrganizationCard({ organization, memberCount }: OrganizationCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/organizations/${organization.id}`);
  };

  return (
    <div onClick={handleClick} className={styles.card}>
      <div className={styles.cardHeader}>
        <h3 className={styles.title}>{organization.name}</h3>
        <span className={styles.roleBadge} data-role={organization.role}>
          {organization.role}
        </span>
      </div>
      <p className={styles.slug}>/{organization.slug}</p>
      {memberCount !== undefined && (
        <p className={styles.memberCount}>
          {memberCount} {memberCount === 1 ? "member" : "members"}
        </p>
      )}
    </div>
  );
}
